import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {fetchSampleSizeSuccess, fetchSampleSizeError, fetchMultiSampleSizeSuccess, fetchMultiSampleSizeError} from '../actions/SampleSize';
import {FETCH_SAMPLE_SIZE, FETCH_MULTI_SAMPLE_SIZE} from 'constants/ActionTypes';
import axios from 'axios';

const DEFAULT_CONFIDENCE_INTERVAL = 0.95;
const DEFAULT_MARGIN_ERROR = 0.05;
const DEFAULT_SUB_PROPS = [0.01];

async function fetchSampleSizeAPI(params) {
  return await axios.post(`${process.env.REACT_APP_RND_API_URL}/sample_size/single-proportion-in-subpopulation`,
    params);
};

function* fetchSampleSizeRequest({ params }) {
  try {
    let fetchedSampleSize = { data: { sample_size: 0 }};
    if (params.volume) {
      fetchedSampleSize = yield call(fetchSampleSizeAPI, {
        "confidence_interval": params.confidence_interval || DEFAULT_CONFIDENCE_INTERVAL,
        "margin_error": params.margin_error || DEFAULT_MARGIN_ERROR,
        "population_size": params.volume,
        "sub_props": params.sub_props || DEFAULT_SUB_PROPS,
      });
    }
    yield put(fetchSampleSizeSuccess({ sample: fetchedSampleSize.data, index: params.index }));
  } catch (error) {
    console.log(error);
    yield put(fetchSampleSizeError(error));
  }
}

export function* fetchSampleSize() {
  yield takeEvery(FETCH_SAMPLE_SIZE, fetchSampleSizeRequest);
}


function* fetchMultiSampleSizeRequest({ params }) {
  try {
    let fetchedSampleSize = [{ sample_size: 0 }];
    if (params.volumes) {
      const requests = params.volumes.map(volume => volume ? call(fetchSampleSizeAPI, {
        "confidence_interval": params.confidence_interval || DEFAULT_CONFIDENCE_INTERVAL,
        "margin_error": params.margin_error || DEFAULT_MARGIN_ERROR,
        "population_size": volume,
        "sub_props": params.sub_props || DEFAULT_SUB_PROPS,
      }) : null);
      fetchedSampleSize = yield all(requests);
    }
    yield put(fetchMultiSampleSizeSuccess({ samples: fetchedSampleSize }));
  } catch (error) {
    console.log(error);
    yield put(fetchMultiSampleSizeError(error));
  }
}

export function* fetchMultiSampleSize() {
  yield takeEvery(FETCH_MULTI_SAMPLE_SIZE, fetchMultiSampleSizeRequest);
}

export default function* rootSaga() {
  yield all([fork(fetchSampleSize), fork(fetchMultiSampleSize)]);
}
